import { API_VERSION } from '../config/configurations';
import { edulaiInstance } from './instances/edulaiInstance';

export function edulaiEmbedding() {
  return edulaiInstance.get(`/api/${API_VERSION}/coachAI/edulaiEmbedding`);
}

export function chat(message) {
  const paramsToSend = {
    params: {
      message
    }
  };
  return edulaiInstance.get(`/api/${API_VERSION}/coachAI/chat`, paramsToSend);
}
